import React, {useContext} from 'react'
import {useStaticQuery, graphql} from "gatsby"
import Img from "gatsby-image"
import {GlobalStateContext} from "../../../context/GlobalContextProvider"

const Jitst2022 = (state) => {
    state = useContext(GlobalStateContext);

    const data = useStaticQuery(graphql`
        query {
            lissabon2022Image: file(relativePath: { eq: "Publications/Scientific/jitst.png" }) {
                childImageSharp {
                    fluid(maxWidth: 250, quality: 90) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            } 
        }
    `)

    return (
        <div className={state.publicationsId}>
            <div className="box">
                <div className="paper-container">
                    <div className="image-container">
                    <Img fluid={data.lissabon2022Image.childImageSharp.fluid} className="image"/>                    
                    </div>
                    <div className="outside">
                        <div className="inside">  
                            <p>Target Groups in German SMEs for Information Security Training:<br/>
                            The Use and Limits of Job Profiles in Designing Training Units</p>
                            <p className="subtitle"> (auf Englisch)</p>
                            <p className="subtitle" >2022</p>
                            <p className="subtitle">
                                <a href="https://infonomics-society.org/wp-content/uploads/Target-Groups-in-German-SMEs-for-Information-Security-Training.pdf"  
                                    target="_blank" 
                                    rel="noreferrer" 
                                    aria-label="">
                                Link zum Artikel
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Jitst2022;